import LoginWithSsoForm from './LoginWithSsoForm';

function LoginWithSsoContent() {
  return <LoginWithSsoForm />;
}
export default LoginWithSsoContent;
